import React from "react";
import styled from "styled-components";
import * as Theme from "../Theme";
import moment from "moment";

function commafy(num) {
  num = num + "";
  var re = /(-?\d+)(\d{3})/;
  while (re.test(num)) {
    num = num.replace(re, "$1,$2");
  }
  return num;
}

export default function ProductPrice(props) {
  let { product } = props;
  if (!product) {
    return null;
  }
  return (
    <Wrapper>
      <Triangle />
      {product.type === "free" ? (
        // 免費
        <div style={{ flex: 1 }}>
          <Price discount={true}>免費課程</Price>
          <Price discount={true}>NT$ 0</Price>
        </div>
      ) : product.discount > 0 &&
        product.type === "fundraising" &&
        moment(product.deadline).diff(moment(), "milliseconds") > 0 ? (
        // 折價
        <div style={{ flex: 1 }}>
          <Price discount={true} style={{ textDecoration: "line-through" }}>
            NT$ {commafy(product.price)}
          </Price>
          <Price>NT$ {commafy(product.discount)}</Price>
        </div>
      ) : (
        <div style={{ flex: 1 }}>
          <Price></Price>
          <Price>NT$ {commafy(product.price)}</Price>
        </div>
      )}
    </Wrapper>
  );
}

//price in product item of product listing page
export function ProductItemPrice(props) {
  let { product } = props;
  if (!product) {
    return null;
  }
  {
    /* {product.discount ? (
            <Price style={{ color: Theme.colors.text }}>
              折價 -${product.discount}
            </Price>
          ) : null} */
  }
  return (
    <ItemPrice style={{ flexShrink: 0, marginBottom: 5 }}>
      {product.type === "free"
        ? "免費課程"
        : product.type === "fundraising" &&
          moment(product.deadline).diff(moment(), "milliseconds") > 0
        ? `NT $${product.discount} 起`
        : `NT $${product.price} 起`}
    </ItemPrice>
  );
}

const Wrapper = styled.div`
  align-self: stretch;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

const Triangle = styled.div`
  width: 0px;
  height: 0px;
  border-left: solid 16px ${Theme.colors.main};
  border-top: solid 26px transparent;
  border-bottom: solid 26px transparent;
  margin: 5px 15px 5px 0;
`;

const Price = styled.div`
  font-weight: 600;
  font-size: 20px;
  color: ${props => (props.discount ? "#ccc" : Theme.colors.text)};
`;

const ItemPrice = styled.div`
  text-align: center;
  color: ${Theme.colors.main};
  font-size: 12px;
`;
